export default __webpack_public_path__ + "static/media/sent.d7f716cc.svg";